export enum SearchType {
  Keyword,
  Map
};
